export const catchHandler = (error: unknown) => {
  // eslint-disable-next-line no-console
  console.log(error);
};

export const SUPPORTED_AGENT_VERSIONS = [
  "2.3.7-9.0",
  "2.4.0-10.0",
  "2.4.0-11.0",
  "2.4.1-11.0",
  "2.4.1-11.1",
  "2.4.0-11.1",
  "2.4.2-12.0",
  "2.5.0-13.0",
  "2.6.0-14.0",
  "2.6.0-15.0",
  "2.7.0-16.0",
  "2.7.0-16.1",
  "2.7.1-16.0",
  "2.7.2-16.1",
  "2.7.3-17.0",
  "2.7.1-17.0",
  "2.8.0-18.0",
  "2.7.1-17.1",
  "2.8.0-18.1",
  "2.8.1-18.2",
  "2.8.0-18.2",
  "2.8.2-18.3",
  "2.8.2-18.4",
  "2.8.2-18.5",
  "2.9.0-19.0",
  "2.9.0-20.0",
  "2.9.1-20.0",
  "2.9.1-21.0",
];

export const eventMap = [
  { id: "license_usage_notification", name: "License Usage Notifications" },
  { id: "task_execution_started", name: "Task Execution - task started" },
  { id: "task_execution_skipped", name: "Task Execution - task skipped" },
  { id: "task_execution_stopped", name: "Task Execution - task stopped" },
  { id: "task_execution_failed", name: "Task Execution - task failed" },
  { id: "task_execution_completed", name: "Task Execution - task Completed" },
  { id: "agent_status_activated", name: "Agent Status - Agent activated" },
  { id: "agent_status_deactivated", name: "Agent Status - Agent deactivated" },
  { id: "agent_status_deployed", name: "Agent Status - Agent deployed" },
  { id: "agent_status_undeploy", name: "Agent Status - Agent undeploy" },
  {
    id: "agent_status_connected_to_other_machine",
    name: "Agent Status - Agent connected to another machine",
  },
];

export const GETMESSAGEBYEVENT = {
  license_usage_notification: [" License changed", ""],
  agent_status_deactivated: [
    " Deactivated",
    " and is not communicating with the Orchestrator",
  ],
  agent_status_activated: [
    " Activated",
    " and has started to communicate with the Orchestrator",
  ],
  agent_status_undeploy: [
    " Undeploy",
    " and is not communicating with the Orchestrator",
  ],
  agent_status_deployed: [
    " Activated",
    " and a task has been deployed for the",
  ],
  agent_status_connected_to_other_machine: [
    "",
    " active and attempting to connect to another machine",
  ],
  task_execution_started: [" task started", " has started "],
  task_execution_skipped: [
    " task skipped",
    " has been skipped because there was another task running at the same time",
  ],
  task_execution_stopped: [" task stopped", " has been forcibly stopped"],
  task_execution_failed: [" task failed", " has been failed"],
  task_execution_completed: [" task completed", " is completed"],
};

export const timeZone = {
  IST: {
    name: "Indian Time (Kolkata)",
    mapping: "Asia/Kolkata",
  },
  PST: {
    name: "Pacific Time (Los Angeles)",
    mapping: "America/Los_Angeles",
  },
  MST: {
    name: "Mountain Time (Phoenix)",
    mapping: "America/Phoenix",
  },
  CST: {
    name: "Central Time (Chicago)",
    mapping: "America/Chicago",
  },
  EST: {
    name: "Eastern Time (New York)",
    mapping: "America/New_York",
  },
  MST_D: {
    name: "Mountain Time (Denver)",
    mapping: "America/Denver",
  },
} as const;

type TimeZoneAbbreviation = keyof typeof timeZone;

export const getTimezoneOffset = (tz: TimeZoneAbbreviation) => {
  const timezone = timeZone[tz];

  const offset = new Intl.DateTimeFormat("en-GB", {
    dateStyle: "short",
    timeStyle: "long",
    timeZone: timezone.mapping,
  }).format(new Date());

  const parts = offset.split(", ");
  const gmtOffset = parts[1].split(" ").pop();

  return `${timezone.name} - (${gmtOffset})`;
};

export default catchHandler;
